import { Image } from "common/types/images";

import { getCdnImageDetails } from "seneca-common/utils/images";

import { Content, ContentSource, ImageAssetParameters } from "../types";

export function getModuleAssets(source: ContentSource): Image[] {
  return source.values as unknown as Image[];
}

export function transformModuleAssets(
  { title, values }: ContentSource,
  assetParams: ImageAssetParameters
): Content {
  return {
    title,
    images:
      values &&
      values.map((value: any) => {
        return {
          ...getCdnImageDetails(value.image, assetParams.default),
          isCorrect: value.isCorrect
        };
      })
  };
}
